import React from 'react'
import { BrowserRouter } from 'react-router-dom'

import Routes from '../Routes'
import { AbilityProvider } from '@shared/AccessManager/AbilityProvider'

const App = () => {
  return (
    <BrowserRouter>
      <AbilityProvider>
        <Routes />
      </AbilityProvider>
    </BrowserRouter>
  )
}

export default App
